<app-modal-header
  [highlighted]="true"
  [separator]="true"
  (close)="close()">
  <span slot="breadcrumb">
    {{'admin.location-modal.title' | translate }}
  </span>
  <span slot="title">
    <app-input-textarea-subtle [FC]="form.controls.internalTitle" [autoFocus]="true" [variant]="'light'" [placeholder]="'admin.location-modal.internal-title.placeholder' | translate"></app-input-textarea-subtle>
  </span>

  <div class="flex justify-content-end relative z-1" style="top: 1.5rem; right: -2.5rem; margin-top: -2rem;">
    <app-location-code [codeFC]="form.controls.code" />
  </div>
</app-modal-header>


<div [formGroup]="form" class="modal-body">


  <div class="grid">

    <div class="col-12">
      <span class="font-bold">
        {{ 'admin.location-modal.title-input.label' | translate }}
      </span>
      <input [formControl]="form.controls.title" pInputText class="w-full" />
    </div>

    <div class="col-12">
      <span class="font-bold">{{ 'admin.location-modal.location-group-input.label' | translate }}</span>
      <p-inputGroup>
        <p-dropdown
          [formControl]="form.controls.locationGroupId"
          [options]="locationGroupOptions"
          optionLabel="label"
          optionValue="value"
          class="w-full input-group-dropdown"
          [class.loading-box]="fetchingLocationGroups"
          styleClass="w-full input-group-dropdown"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex justify-content-between align-items-center">
              <span>{{ option.label }}</span>

              @if (option.value) {
                <i (click)="onUpdateLocationGroup(option, $event)" class="pi pi-pencil cursor-pointer">
                </i>
              }
            </div>
          </ng-template>
        </p-dropdown>
        <button
          (click)="onNewLocationGroup()"
          pButton
          [label]="'admin.location-modal.location-group-new-btn.label' | translate"
          class="p-button-outlined p-button-sm flex-shrink-0 white-space-nowrap">
        </button>

      </p-inputGroup>

    </div>

  </div>

  <p-divider layout="horizontal" class="block compensate-modal-body-x-padding"></p-divider>


  <div class="grid">
    <div class="col-12 flex flex-column gap-2">
      <span class="font-bold">
        {{ 'admin.location-modal.maplink' | translate }}
      </span>
      <p-inputGroup (click)="$event.stopPropagation()">
        <p-inputGroupAddon [style.background]="'var(--surface-a)'" class="border-right-none pr-0">
          <div class="flex align-items-center justify-content-center" style="width: 1.4rem; height: 1.4rem;">
            <i class="pi pi-map-marker"></i>
          </div>
        </p-inputGroupAddon>
        
        <input [formControl]="form.controls.mapUrl" [placeholder]="'admin.location-modal.maplink' | translate" type="text" pInputText class="border-left-none">
    
        <p-inputGroupAddon>
          <a [href]="(form.controls.mapUrl.value || '') | externalHref" target="_blank" rel="noopener noreferrer" [ngbTooltip]="'admin.location-modal.maplink.tooltip' | translate">
            <i class="pi pi-external-link" style="color: var(--text-color-secondary);"></i>
          </a>
        </p-inputGroupAddon>
      </p-inputGroup>
      <!-- <span class="p-float-label">
        <input id="mapUrl" formControlName="mapUrl" type="text" pInputText class="w-full">
        <label for="mapUrl">{{'admin.location-modal.maplink' | translate }}</label>
      </span> -->
    </div>
  </div>
  
  <p-divider layout="horizontal" class="block compensate-modal-body-x-padding"></p-divider>

  <div class="grid">

    <div class="col-12 flex flex-column gap-2 flex-1">
      <span class="font-bold">
        {{ 'admin.location-modal.address.label' | translate }}
      </span>
  
      <div class="flex flex-column" formGroupName="address">
        <!-- Ulice + c. p. -->
        <div class="flex flex-row">
          <div class="col-9 flex flex-column gap-1">
            <span>
              {{ 'admin.location-modal.address.street.label' | translate }}
            </span>
            <input formControlName="street" [placeholder]="'admin.location-modal.address.street.label' | translate" type="text" pInputText class="flex w-full">
          </div>
  
          <div class="col-3 flex flex-column gap-1">
            <span style="cursor: default;">&nbsp;</span>
            <input formControlName="buildingNumber" [placeholder]="'admin.location-modal.address.building-number.label' | translate" type="text" pInputText class="flex w-full">
          </div>
        </div>
  
        <!-- Mesto + PSC -->
        <div class="flex flex-row">
          <div class="col-9 flex flex-column gap-1">
            <span>
              {{ 'admin.location-modal.address.city.label' | translate }}
            </span>
            <input formControlName="city" [placeholder]="'admin.location-modal.address.city.label' | translate" type="text" pInputText class="flex w-full">
          </div>
  
          <div class="col-3 flex flex-column gap-1">
            <span>
              {{ 'admin.location-modal.address.zip.label' | translate }}
            </span>
            <input formControlName="zip" [placeholder]="'admin.location-modal.address.zip.label' | translate" type="text" pInputText class="flex w-full">
          </div>
        </div>
  
        <!-- Zeme -->
        <div class="col-6 flex flex-column gap-1">
          <span>
            {{ 'admin.location-modal.address.country.label' | translate }}
          </span>
          <app-country-dropdown-input [floatLabel]="false" [countryFC]="form.controls.address.controls.country" [countryCodeFC]="form.controls.address.controls.countryCode" />
        </div>
      </div>
    </div>

  </div>

  <p-divider layout="horizontal" class="block compensate-modal-body-x-padding"></p-divider>

  <div class="grid">
    <div class="col-12 flex flex-column field gap-2">
      <span class="font-bold">
        {{ 'admin.location-modal.calendars' | translate }}
      </span>
      <app-google-calendar-sync [disabled]="!location?.id" disabledTooltip="admin.location-modal.calendars.disabled.tooltip" [locationId]="location?.id" />
    </div>
  </div>
    
  <p-divider layout="horizontal" class="block compensate-modal-body-x-padding"></p-divider>

  <div class="grid">
    <div class="col-12 flex flex-column field gap-2">
      <span class="font-bold">
        {{ 'admin.location-modal.note' | translate }}
      </span>
      <textarea [autoResize]="true" formControlName="note" pInputTextarea class="w-full" [placeholder]="'admin.location-modal.note' | translate"></textarea>
    </div>
  </div>


</div>


<div class="modal-footer">
  <button
    [loading]="saving"
    [disabled]="saving"
    (click)="onSubmit()"
    pButton
    label="{{'admin.location-modal.save' | translate }}">
  </button>

</div>
